// Регистрация панелей официального контура в каркасе. Побочный эффект при загрузке модуля:
// раздел объявляет, что умеет рисовать в стопке панелей, а каркас остаётся без знания о нём.

import { registerPanel } from '@/layout/panel-registry';

import {
  PANEL_IMPORT,
  PANEL_OFFICIAL_EMPLOYEE,
  PANEL_REVIEW,
  PANEL_TRANCHES,
  PANEL_WRITS,
} from '../../route';

import { EmployeePanel } from './EmployeePanel';
import { ImportPanel } from './ImportPanel';
import { ReviewPanel } from './ReviewPanel';
import { TranchesPanel } from './TranchesPanel';
import { WritOrdersPanel } from './WritOrdersPanel';

registerPanel(PANEL_TRANCHES, {
  title: () => 'Строка периода',
  render: ({ id }) => <TranchesPanel id={id} />,
});

registerPanel(PANEL_WRITS, {
  title: () => 'Исполнительные документы',
  render: ({ id }) => <WritOrdersPanel id={id} />,
});

registerPanel(PANEL_REVIEW, {
  title: () => 'Разбор замечаний',
  render: ({ id }) => <ReviewPanel id={id} />,
});

registerPanel(PANEL_IMPORT, {
  title: () => 'Загрузка сумм',
  render: ({ id }) => <ImportPanel id={id} />,
});

registerPanel(PANEL_OFFICIAL_EMPLOYEE, {
  title: () => 'Человек в официальном контуре',
  render: ({ id }) => <EmployeePanel id={id} />,
});
